import { state } from '../state'
import { post } from '@webapp2/shared/services/api'

const pollingPeriod30mins = 30 * 60 * 1000

export function sessionRefresher() {
  setInterval(() => {
    if (state.user) {
      console.log('Refreshing session')
      void post('fetch-user', {})
    }
  }, pollingPeriod30mins)
}
